import { Skeleton } from "antd";
import { useEffect, useState } from "react";

import { cn } from "@btnet/utilities-core";

interface IJobPickerLogoProps {
    url: string;
}

export const JobPickerLogo: React.FunctionComponent<IJobPickerLogoProps> = ({ url }) => {
    const [status, setStatus] = useState<"loading" | "loaded" | "error">("loading");

    // Reset back to loading when the url changes (e.g. switching builders) so a previously
    // errored or loaded logo doesn't prevent the new one from rendering.
    useEffect(() => {
        setStatus("loading");
    }, [url]);

    if (status === "error") {
        return null;
    }

    return (
        <div className="w-10 h-10 flex items-center justify-center">
            {status === "loading" && (
                <div data-testid="job-picker-logo-skeleton" className="w-10 h-10">
                    <Skeleton.Image className="w-10 h-10 rounded-md" />
                </div>
            )}
            <img
                className={cn("max-h-10 max-w-10 object-contain rounded-md", {
                    hidden: status !== "loaded",
                })}
                src={url}
                alt="Company Logo"
                onLoad={() => setStatus("loaded")}
                onError={() => setStatus("error")}
            />
        </div>
    );
};
